export default [
  // async function guardian(to, from) {
  //   // const isLogged = localStorage.getItem('isLogged');
  //   // if (to.name !== 'Home' && !isLogged) {
  //   if (to.name !== 'Home' && to.name !== 'LoginOk') {
  //     return {name: 'Home'};
  //   }
  // },
];
